"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M6.844 6.6L6 8.763v8.839h3V19.2h1.688l1.593-1.598h2.438L18 14.31V6.6H6.844zm10.031 7.146L15 15.626h-3l-1.594 1.6v-1.6H7.875V7.729h9v6.018zM15 9.891v3.291h-1.125V9.891H15zm-3 0v3.291h-1.125V9.891H12z" }), "Twitch");
//# sourceMappingURL=Twitch.js.map